import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import copyApiImage from "../../..//assets/TailoredGeneration/images/tg-overview.png";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import CopyApiTokenButton from "../../../components/common/OverviewFooter/CopyApiTokenButton";
import footerStyles from "../../../components/common/OverviewFooter/OverviewFooter.module.scss";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";
import styles from "./TgOverview.module.scss";

const TgOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "overview" });
	const { t: tTg } = useTranslation("tg");
	const navigate = useSecureNavigate();

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: "",
				description: "",
				hideCopyTokenBtn: true,
				className: styles.hideFooter,
			}}
			pageName="overview"
		>
			<Box className={styles.centerContainer}>
				<img src={copyApiImage} className={styles.image} />
				<Box className={styles.textBlock}>
					<Typography
						className={footerStyles.description}
						dangerouslySetInnerHTML={{ __html: t("copyApiToken.description") }}
					/>
					<Box className={styles.buttons}>
						<CopyApiTokenButton buttonType="primaryMedium" />
						<BriaButton
							onClick={() => {
								navigate(RouterConstants.NEW_TG.PROJECTS.fullPath);
							}}
							buttonType="secondaryMedium"
						>
							{tTg("projects.tab")}
						</BriaButton>
					</Box>
				</Box>
			</Box>
		</ConsoleOverviewLayout>
	);
};

export default observer(TgOverview);
